import { buildHeader, buildQueryParam } from "./baseService";
import { getJson } from "../utils/httpHelper";
import {CATEGORY_TYPE_OF_LIST} from "../constants/Category";

export const getVideoListByCategory = async (baseUrl, apiKey, tenantId, categoryId, params) => {
    const api = await fetch(buildQueryParam(`${baseUrl}/clients/vod-category/${categoryId}/videos/`, params), {
        headers: buildHeader(apiKey),
    });
    return getJson(api);
}

export const getVideosByCategory = async (baseUrl, apiKey, tenantId, categoryId, params) => {
    const api = await fetch(buildQueryParam(`${baseUrl}/category/single/${CATEGORY_TYPE_OF_LIST.Video}/${categoryId}/`, params), {
        headers: buildHeader(apiKey),
    });
    return getJson(api);
}

export const getVideoById = async (baseUrl, apiKey, uuid) => {
    let url = `${baseUrl}/media/single/${CATEGORY_TYPE_OF_LIST.Video}/${uuid}/`;
    const accessCode = new URLSearchParams(window.location.search).get('access_code');
    if (accessCode) {
        url += `?access_code=${encodeURIComponent(accessCode)}`;
    }
    const api = await fetch(url, {
        headers: buildHeader(apiKey),
    });
    return getJson(api);
}

export const searchVideo = async (baseUrl, apiKey, category_type, params) => {
    const api = await fetch(buildQueryParam(`${baseUrl}/media/list/${category_type}/`, params), {
        headers: buildHeader(apiKey),
    });
    return getJson(api);
}
